<script setup lang="ts">
import Circle from './Circle.vue'

withDefaults(
  defineProps<{
    label?: string
    white?: boolean
    yellow?: boolean
  }>(),
  {
    label: '',
    white: false,
    yellow: false,
  },
)
</script>

<template lang="pug">
.flex.col-24
  Circle.s-40(:white="white" :yellow="yellow")
  .title.typ-18-26-600(v-if="label || $slots.default")
    slot
      | {{ $t(label) }}
</template>

<style scoped>
.title {
  color: var(--cue-content-neutral-secondary);
}
</style>
